import {Icons} from '../icons';
import {formatDate} from '../lib/dates';
import type {CanvasData} from './types';

interface Props {
  canvas: CanvasData;
}

export const CanvasHero = ({canvas}: Props) => {
  return (
    <div className="pb-6">
      <div className="mb-2 text-xs font-medium uppercase tracking-widest text-muted-foreground">
        {formatDate(canvas.createdAt, {
          style: 'long',
        })}
      </div>
      {canvas.title && (
        <h1 className="font-serif text-3xl font-normal leading-tight tracking-tight text-foreground">
          {canvas.title}
        </h1>
      )}
      <div className="mt-3 flex items-center gap-1.5 text-xs text-muted-foreground">
        <Icons.clock className="size-3 shrink-0" />
        <span>
          Last modified {formatDate(canvas.updatedAt, {style: 'long'})}
        </span>
      </div>
    </div>
  );
};
